(ns practitest.frontend.xbot2.schedule
  (:require
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.components.modal :as modal]
    [practitest.frontend.components.forms :as forms]
    [practitest.frontend.components.datepicker :as datepicker]
    [practitest.frontend.common.i18n :refer [format-translation get-translation] :as i18n]
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.notifications :as notifications]
    [clojure.string :as str]
    [practitest.frontend.components.spinners :as spinners]
    [practitest.frontend.subs :as subs]
    [tick.core :as tick]
    [re-frame.core :as re-frame]
    [practitest.frontend.events :as events]
    [ajax.core :as ajax]
    [practitest.frontend.common.dom :as dom]))

(defn- parse-time [s]
  (when (and s
             (not (str/blank? s)))
    (tick/time s)))

(defn- parse-date [s]
  (when (and s
             (not (str/blank? s)))
    (tick/date s)))

(defn backend->frontend [object]
  (let [type (:type object)
        time (parse-time (:time object))
        date (parse-date (:date object))
        instant (when (and time date)
                  (tick/instant (tick/at date time)))]
    (case type
      "once-at"
      {:type type
       :instant instant}

      "weekly"
      {:type type
       :days (set (:days object))
       :weekly-time time}

      "daily"
      {:type type
       :daily-time time}

      ;else
      nil)))

(defn frontend->backend [object]
  (let [type (:type object)]
    (case type
      "once-at"
      {:type type
       :date (str (tick/date (:instant object)))
       :time (str (tick/time (:instant object)))}

      "weekly"
      {:type type
       :days (:days object)
       :time (str (:weekly-time object))}

      "daily"
      {:type type
       :time (str (:daily-time object))}

      ;else
      nil)))

(defn radio-button
  [{:keys [value
           content

           on-change
           on-dirty

           label]}]
  [:div.form-check
   [:label.form-label
    [:input.form-check-input
     {:type      :radio
      :value     value
      :checked   (boolean (= value content))
      :on-change (fn [e]
                   (when on-change
                     (on-change content))

                   (when on-dirty
                     (on-dirty)))}]
    label]])

(defn recurrence-radio
  [recurrence-type code label set-field-value!]
  [radio-button {:content   code
                 :value     recurrence-type
                 :on-change (set-field-value! :type)
                 :label     label}])


;; Copied from ui/button-selector, slightly adjusted for Bootstrap 5
(defn button-selector
  "Component for choosing one or multiple options.
   Looks like a button group.
   If `:multi?` is `true`, allows to choose multiple options and the datastructure in `fieldstate` will be a set.
   Otherwise the datastructure in `fieldstate` is scalar.
   The `buttons` is a vector of tuples `[option label]`.
   `fieldstate` is a cursor/atom (ratom)
   `disabled?` is changed by the radio buttons selection."
  [{:keys [value

           on-change
           on-dirty

           buttons
           multi?
           disabled?
           class]}]
  (letfn
    [(active? [k]
       (if multi?
         (contains? (set value) k)
         (= k value)))
     (toggle [k]
       (when on-change
         (on-change
           (if multi?
             (if (contains? (set value) k)
               (disj (set value) k)
               (conj (set value) k))
             (if (= k value) nil k)))))]
    (into [:div.btn-group]
          (for [[k label] buttons]
            ^{:key k}
            [:a.btn.btn-outline-pt-secondary
             {:href     "#"
              :disabled disabled?
              :class    (str class (when (active? k) " active") (when disabled? " disabled"))
              :on-click (fn [e]
                          (dom/prevent-default e)
                          (.blur (.-target e)) ;; remove the glow around the button
                          (when on-dirty
                            (on-dirty))
                          (toggle k))}
             label]))))

;; Copied and adapted from old implementation
(defn schedule-str-display [{:keys [type
                                    daily-time
                                    weekly-time
                                    instant
                                    days]
                             :as object}]
  (case type
    "once-at"
    [:div.suite-sched-str
     [icons/calendar-check]
     [:span " Scheduled to run at "]
     [:span (str (fu/formatted-date-time instant) " ")]]

    "daily"
    [:div.suite-sched-str
     [icons/svg-arrow-repeat]
     [:span " Scheduled to run every day at "]
     [:span (str daily-time)]]

    "weekly"
    [:div.suite-sched-str
     [icons/svg-arrow-repeat]
     [:span " Scheduled to run every "]
     [:span
      (str
        (str/join ", "
                  (map #(subs % 0 2)
                       (map str/capitalize
                            days)))
        " at ")]
     [:span (str weekly-time " ")]]

    ;else
    [:span "Invalid type" (pr-str type)]))

(defn schedule-str
  [run-later]
  (when run-later
    [schedule-str-display (backend->frontend run-later)]))

;;
;; get-form-state (fn []) -> form-state (derefed)
;; set-form-state (fn [form-state]) -> void
;;
(defn recurrence-modal [{:keys [get-form-state
                                set-form-state

                                on-request-close
                                on-save
                                on-remove

                                open?
                                container-ref
                                new?
                                run-later

                                saving?
                                removing?]}]
  (let [form-state (get-form-state)

        get-field-value (fn [field-id]
                          (forms/get-field-value form-state field-id))
        set-field-value! (fn [field-id]
                           (fn [v]
                             (set-form-state (forms/assoc-field-value form-state field-id v))))

        {:keys [type
                days
                weekly-time
                instant
                daily-time]
         :as object}
        (forms/get-fields-values form-state [:type :days :weekly-time :instant :daily-time])

        valid-state? (case type
                       "weekly"
                       (and (some? days)
                            (some? weekly-time))

                       "once-at"
                       (some? instant)

                       "daily"
                       (some? daily-time)

                       ;else
                       false)]
    [modal/bootstrap-modal
     {:is-open?         open?
      :container-ref    container-ref
      :on-request-close on-request-close
      :class            "schedule-modal"
      :close-button?    true}

     "Schedule Run:"

     [:<>
      (when run-later
        [:div.row.mb-1
         [:div.col-12
          [schedule-str run-later]]])

      ;; Daily
      [:div.row.align-items-center.mb-2
       [:div.col-3
        [recurrence-radio type "daily" "Daily" set-field-value!]]
       [:div.col-3
        [datepicker/time-picker {:class     "form-control"
                                 :value     (get-field-value :daily-time)
                                 :on-change (set-field-value! :daily-time)
                                 :disabled? (not= "daily" type)}]]]

      ;; Once
      [:div.row.align-items-center.mb-2
       [:div.col-3
        [recurrence-radio type "once-at" "Once at" set-field-value!]]
       [:div.col-5
        [datepicker/instant-picker {:class     "form-control"
                                    :value     (get-field-value :instant)
                                    :on-change (set-field-value! :instant)
                                    :disabled? (not= "once-at" type)}]]]

      ;; Weekly
      (let [disabled? (not= "weekly" type)]
        [:div.row.align-items-center.mb-2
         [:div.col-3
          [recurrence-radio type "weekly" "Weekly" set-field-value!]]

         [:div.col-6
          [button-selector
           {:value     (get-field-value :days)
            :on-change (set-field-value! :days)

            :buttons   [["sunday" "Su"]
                        ["monday" "Mo"]
                        ["tuesday" "Tu"]
                        ["wednesday" "We"]
                        ["thursday" "Th"]
                        ["friday" "Fr"]
                        ["saturday" "Sa"]]
            :multi?    true
            :disabled? disabled?}]]
         [:div.col-3
          [datepicker/time-picker {:value     (get-field-value :weekly-time)
                                   :on-change (set-field-value! :weekly-time)
                                   :disabled? disabled?}]]])]

     [:<>
      (when (and on-remove
                 (not new?))
        [:button.btn.btn-outline-pt-secondary.me-4
         {:disabled (or saving? removing?)
          :on-click (fn [e]
                      (on-remove))}

         (when removing?
           [:span.me-1
            [spinners/inline-spinner-border]])

         "Remove"])

      [:button.btn..btn-outline-pt-secondary
       {:disabled (or saving? removing?)
        :on-click on-request-close}
       "Cancel"]
      [:button.btn.btn-primary
       {:disabled (or (not valid-state?)
                      saving?)
        :on-click (fn [e]
                    (when on-save
                      ;; Save object (collected from form state)
                      (on-save object)))}

       (when saving?
         [:span.me-1
          [spinners/inline-spinner-border]])

       "Save"]]]))

;; re-frame wiring stuff
(def ^:private root-db-key :schedule-state)

(re-frame/reg-sub
  ::state
  root-db-key)

;; TODO: entity-id ??
(re-frame/reg-sub
  ::open?
  (fn [_]
    (re-frame/subscribe [::state]))
  (fn [state _]
    (:open? state)))

(re-frame/reg-sub
  ::form-state
  (fn [_]
    (re-frame/subscribe [::state]))
  (fn [state _]
    (:form state)))

(re-frame/reg-sub
  ::saving?
  (fn [_]
    (re-frame/subscribe [::state]))
  (fn [state _]
    (:saving? state)))

(re-frame/reg-event-db
  ::open
  (fn [db _]
    (assoc-in db [root-db-key :open?] true)))

(re-frame/reg-event-db
  ::close
  (fn [db _]
    (assoc-in db [root-db-key :open?] false)))

(re-frame/reg-event-db
  ::set-form-state
  (fn [db [_ form-state]]
    (assoc-in db [root-db-key :form] form-state)))

(defn saved-schedule [{db :db} _]
  {:db         (update db root-db-key assoc :saving? false)
   :dispatch-n [[::close]
                [::events/fetch-entity :current]
                [::notifications/success "Schedule saved" {:auto-close 1000}]]})

(re-frame/reg-event-fx
  ::saved-schedule
  saved-schedule)

(re-frame/reg-event-fx
  ::save-schedule-error
  (fn [{db :db} _]
    {:db       (update db root-db-key assoc :saving? false)
     :dispatch [::notifications/error "Error saving schedule" {:auto-close 1000}]}))

(defn save-schedule [{db :db} [_ value entity-id]]
  {:db (update db root-db-key assoc :saving? true)
   :http-xhrio
   {:method          :post
    :uri             (broutes/get-url "suites#set_recurrence"
                                      {:p_id (subs/get-current-project-id db)
                                       :id   entity-id})
    :params          (frontend->backend value)
    :format          (ajax/json-request-format)
    :response-format (ajax/json-response-format)
    :on-success      [::saved-schedule]
    :on-failure      [::save-schedule-error]}})

(re-frame/reg-event-fx
  ::save-schedule
  save-schedule)

(defn remove-schedule [{db :db} [_ entity-id]]
  {:db (update db root-db-key assoc :saving? true)
   :http-xhrio
   {:method          :post
    :uri             (broutes/get-url "suites#delete_recurrence"
                                      {:p_id (subs/get-current-project-id db)
                                       :id entity-id})
    :format          (ajax/url-request-format)
    :response-format (ajax/raw-response-format)
    :on-success      [::saved-schedule]
    :on-failure      [::save-schedule-error]}})

(re-frame/reg-event-fx
  ::remove-schedule
  remove-schedule)

(defn modal-wrapper
  [container-ref run-later entity-id]
  (let [saving-schedule? @(re-frame/subscribe [::saving?])]

    [recurrence-modal
     {:open?            @(re-frame/subscribe [::open?])
      :container-ref    container-ref
      :on-request-close #(re-frame/dispatch [::close])

      :set-form-state   (fn [form-state]
                          (re-frame/dispatch [::set-form-state form-state]))
      :get-form-state   (fn []
                          @(re-frame/subscribe [::form-state]))

      :on-save          (fn [new-object]
                          (re-frame/dispatch [::save-schedule new-object entity-id]))
      :on-remove        (fn []
                          (re-frame/dispatch [::remove-schedule entity-id]))

      :new?             (nil? run-later)
      :run-later        run-later
      :saving?          saving-schedule?
      :removing?        saving-schedule?}]))

(defn schedule-btn
  [_ _]
  (let [container-ref (atom nil)]
    (fn [run-later entity-id]
      (let [object (backend->frontend run-later)]
        [:<>
         ;; Attach modal to root node of shadow DOM or body
         [modal-wrapper container-ref run-later entity-id]

         [:button.btn.btn-pt-success.me-2
          {:ref      (dom/root-ref-handler container-ref)
           :on-click (fn [e]
                       (re-frame/dispatch [::set-form-state (forms/init-form-state {} object)])
                       (re-frame/dispatch [::open]))}
          (get-translation "generic.xbot.schedule" "Schedule")]]))))

(defn schedule-btn2
  [{:keys [container-ref
           run-later
           entity-id]
    :as   props}]
  (let [object (backend->frontend run-later)]
    [:<>
     [modal-wrapper container-ref run-later entity-id]

     [buttons/button
      {:toolbar? true
       :on-click (fn [e]
                   (re-frame/dispatch [::set-form-state (forms/init-form-state {} object)])
                   (re-frame/dispatch [::open]))
       :icon [icons/mux-calendar-manual]
       :class "hide-text"
       :title (get-translation "generic.xbot.schedule" "Schedule")
       :text (get-translation "generic.xbot.schedule" "Schedule")}]]))
